import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateQueries, setQueryData } from '../helpers'
import { getExportPortals, getExportSync, getExportWebsites, handleAdsExport, triggerExportSync } from './functions'
import { ExportAdsPayload, ExportAdsSuccess, ExportPortal, ExportSync, ExportWebsite } from './types'

const exportApi = {
    GetPortals: {
        useQuery: (options?: Omit<UseQueryOptions<ExportPortal[], AxiosError>, 'queryKey' | 'queryFn'>) => {
            return useQuery({
                queryKey: ['export', 'portals'],
                queryFn: getExportPortals,
                staleTime: 5 * 60 * 1000,
                ...options,
            })
        },
    },
    GetWebsites: {
        useQuery: (options?: Omit<UseQueryOptions<ExportWebsite[], AxiosError>, 'queryKey' | 'queryFn'>) => {
            return useQuery({
                queryKey: ['export', 'websites'],
                queryFn: getExportWebsites,
                staleTime: 5 * 60 * 1000,
                ...options,
            })
        },
    },
    GetSync: {
        useQuery: (options?: Omit<UseQueryOptions<ExportSync, AxiosError>, 'queryKey' | 'queryFn'>) => {
            return useQuery({
                queryKey: ['export', 'sync'],
                queryFn: getExportSync,
                staleTime: 60 * 1000,
                ...options,
            })
        },
    },
    TriggerSync: {
        useMutation: (options?: UseMutationOptions<ExportSync, AxiosError>) => {
            return useMutation({
                mutationKey: ['export', 'synchronize'],
                mutationFn: triggerExportSync,
                onSuccess: (data) => setQueryData(['export', 'sync'], data),
                ...options,
            })
        },
    },
    ExportAds: {
        useMutation: (options?: UseMutationOptions<ExportAdsSuccess[], Error, ExportAdsPayload>) =>
            useMutation({
                mutationFn: (data) => handleAdsExport(data),
                onSuccess: (_, variables) => {
                    const { properties, websites } = variables

                    // invalidation for export tab data
                    properties?.forEach((id) => invalidateQueries(['properties', id.toString()]))
                    // invalidation for web column
                    websites?.length && invalidateQueries(['properties', 'list'])
                },
                ...options,
            }),
    },
}

export default exportApi
